<template>
  <div class="stk-p-8">
    <ClientGroupsView />
  </div>
</template>

<script>
import ClientGroupsView from '@frontend/ui/views/client-groups/ClientGroupsView.vue';

export default {
  components: {
    ClientGroupsView,
  },
}
</script>